import React from "react";
import { Accordion } from "@mantine/core";
import styled from "styled-components";
import { nonInteractiveListItemClass } from "components/common/ExpandableListItem";
const StyledAccordion = styled(Accordion)`
  .${nonInteractiveListItemClass} {
    padding-left: 30px;
  }

  .mantine-Accordion-root {
    .${nonInteractiveListItemClass} {
      padding-left: 0;
    }
  }
`;
const ExpandableList = ({
  children = void 0,
  value = void 0,
  defaultValue = void 0,
  className = void 0,
  onChange = void 0
}) => /* @__PURE__ */ React.createElement(
  StyledAccordion,
  {
    chevronPosition: "left",
    multiple: true,
    variant: "unstyled",
    onChange,
    value,
    defaultValue,
    className
  },
  children
);
export default ExpandableList;
